import React from "react";
import "./App.css";
import BarGraph from "./Barchart-generic-component/Bargraph";
import "./Barchart-generic-component/Bargraph";

export function Bargraphs({ height, width, loading = false, data = [], barWidth, maxWidth }) {
  return (
    // <div style={{ position: "sticky", top: "0", zIndex: "9999999" }}>
      <BarGraph
       height={height}
      width={width}
      data={data}
      loading={loading}
      barWidth={barWidth}
      maxWidth={maxWidth}
      ></BarGraph>
    // </div>
  );
}

export default Bargraphs;
